import { useState } from 'react'
import { Clear, Sync } from '@mui/icons-material'
import { CircularProgress, ListItemIcon, MenuItem } from '@mui/material'
import { ProjectGridField } from '@/types/fields'
import { useBulkEditValueContext } from './BulkEditValueProvider'
import useBulkActionCounts from './useBulkActionCounts'

type BulkFieldResetMenuItemProps = {
  closeMenu: () => void
  field: ProjectGridField
  variant: 'clear' | 'removeManual'
} & ReturnType<typeof useBulkActionCounts>

export default function BulkFieldResetMenuItem({
  closeMenu,
  field,
  variant,
  matchingRows,
  displayCount,
}: BulkFieldResetMenuItemProps) {
  const {
    openClearConfirm,
    openRemoveManualConfirm,
    pendingFieldId,
    selectedAllDocsCount,
    fetchAllMatchingRows,
  } = useBulkEditValueContext()

  const isManualNotAllowed = field.input_behavior === 'manual_not_allowed'
  const isDisabled =
    displayCount === 0 || !!pendingFieldId || isManualNotAllowed

  const [isLoadingAll, setIsLoadingAll] = useState(false)

  const openConfirm =
    variant === 'clear' ? openClearConfirm : openRemoveManualConfirm

  async function handleClick() {
    if (selectedAllDocsCount) {
      setIsLoadingAll(true)
      const { allMatchingRows } = await fetchAllMatchingRows(field)
      setIsLoadingAll(false)
      closeMenu()
      openConfirm(field, allMatchingRows)
    } else {
      closeMenu()
      openConfirm(field, matchingRows)
    }
  }

  return (
    <MenuItem disabled={isDisabled || isLoadingAll} onClick={handleClick}>
      <ListItemIcon>
        {isLoadingAll ? (
          <CircularProgress size={20} />
        ) : variant === 'clear' ? (
          <Clear fontSize="small" />
        ) : (
          <Sync fontSize="small" />
        )}
      </ListItemIcon>
      {variant === 'clear' ? `Clear ${field.name}` : 'Remove Manual Values'}
    </MenuItem>
  )
}
